jQuery(document).ready(function($){
  $('.mMenu').on('click',function(){
    // $('#site-header').toggleClass("navOpen");
    $('.menu-mainmenu-container').slideToggle(300);
  });

  //$('.mapToggle').on('click', function(){
    //$('#lang_sel_list').slideToggle();
  //});

  $('.contact-link').on('click', function(){
    console.log('wlwl');
    var linkVal = $(this).find('a').attr('data-value');
    console.log(linkVal);
  });

	// Header scroll function
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	//var navbarHeight = $('#site-header').outerHeight();
  var navbarHeight = 0;
	$(window).scroll(function(event){
		didScroll = true;

	});
	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 0);
	function hasScrolled() {


		var st = $(this).scrollTop();
		if (st==0) {

			if($("body").hasClass("menuOpen")) {
				$('#site-header').addClass('scrolled white-menu');
			}
			else {
				$('#site-header').removeClass('scrolled white-menu');
				$('#site-header').removeClass('scroll-down');
			}

		}
		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
		return;
		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight){
			// Scroll Down
			$('#site-header').removeClass('scroll-up').addClass('scrolled');
			setTimeout(function () {
				$('#site-header').addClass('scroll-down');
			}, 0);
		} else {
			// Scroll Up
			if(st + $(window).height() < $(document).height()) {
				$('#site-header').addClass('scroll-up');
			}
		}
		lastScrollTop = st;
	}
});

jQuery(document).ready(function($){
  // When the window has finished loading create our google map below
  google.maps.event.addDomListener(window, 'load', init);

  function init() {
      // Basic options for a simple Google Map
      // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
      var mapOptions = {
          // How zoomed in you want the map to start at (always required)
          zoom: 10,
          scrollwheel: false,
          // The latitude and longitude to center the map (always required)
          center: new google.maps.LatLng(58.764948,17.3796933), // Coffice

          // How you would like to style the map.
          // This is where you would paste any style found on Snazzy Maps.
          styles: [{"elementType":"geometry","stylers":[{"hue":"#ff4400"},{"saturation":-68},{"lightness":-4},{"gamma":0.72}]},
          {"featureType":"road","elementType":"labels.icon"},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"hue":"#0077ff"},
          {"gamma":3.1}]},{"featureType":"water","stylers":[{"hue":"#00ccff"},{"gamma":0.44},{"saturation":-33}]},
          {"featureType":"poi.park","stylers":[{"hue":"#44ff00"},{"saturation":-23}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"hue":"#007fff"},
          {"gamma":0.77},{"saturation":65},{"lightness":99}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"gamma":0.11},
          {"weight":5.6},{"saturation":99},{"hue":"#0091ff"},{"lightness":-86}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"lightness":-48},
          {"hue":"#ff5e00"},{"gamma":1.2},{"saturation":-23}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"saturation":-64},{"hue":"#ff9100"},
          {"lightness":16},{"gamma":0.47},{"weight":2.7}]}]
      };



      // Get the HTML DOM element that will contain your map
      // We are using a div with id="map" seen below in the <body>
      var mapElement = document.getElementById('map');

      // Create the Google Map using our element and options defined above
      var map = new google.maps.Map(mapElement, mapOptions);


      // Let's also add a marker while we're at it
      var image = '/images/map-pointer-.png';
      var marker = new google.maps.Marker({
          position: new google.maps.LatLng(58.764948,17.3796933),
          map: map,
          title: 'Studsvik Tech Park',
          icon: image
      });

      marker.addListener('click', function() {
        infowindow.open(map, marker);
      });




  }
});

jQuery(document).ready(function($){
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
        return false;
      }
    }
  });
});

$(window).scroll(function() { // when the page is scrolled run this
    if($(this).scrollTop() != 0) { // if you're NOT at the top
        $('.go_to_top').fadeIn("normal"); // fade in
    } else { // else
        $('.go_to_top').fadeOut("normal"); // fade out
    }
});

$('.go_to_top').click(function() { // when the button is clicked
    $('body,html').animate({scrollTop:0},1000); // return to the top with a nice animation
});

//@prepros-prepend header.js
//@prepros-prepend googlemaps_custom.js
//@prepros-prepend smooth.js
//@prepros-prepend scroll_hide.js

